import { render, staticRenderFns } from "./PrecoEmploiStage.vue?vue&type=template&id=0562da52&"
import script from "./PrecoEmploiStage.vue?vue&type=script&lang=js&"
export * from "./PrecoEmploiStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports